const FavIcon32x32ShortcutIcon = {
    rel: 'shortcut icons',
    type: 'image/png',
    href: 'https://pastatic.picsart.com/cms-pastatic/897d8248-6192-4246-93e4-f99389acd13c.png',
};
const FavIcon16x16 = {
    rel: 'icon',
    sizes: '16x16',
    href: 'https://pastatic.picsart.com/cms-pastatic/a955cef0-f4ba-415c-bb7a-722f01a68cf6.png',
};
const FavIcon32x32 = {
    rel: 'icon',
    sizes: '32x32',
    href: 'https://pastatic.picsart.com/cms-pastatic/897d8248-6192-4246-93e4-f99389acd13c.png',
};
const FavIcon48x48 = {
    rel: 'icon',
    sizes: '48x48',
    href: 'https://pastatic.picsart.com/cms-pastatic/c9d4e730-640a-4bcc-8b74-5fbbdb54fabb.png',
};
const FavIcon57x57 = {
    rel: 'icon',
    sizes: '57x57',
    href: 'https://pastatic.picsart.com/cms-pastatic/f8f069b8-91fc-4e12-b807-e1196fccd9e4.png',
};
const FavIcon60x60 = {
    rel: 'icon',
    sizes: '60x60',
    href: 'https://pastatic.picsart.com/cms-pastatic/3fbff40d-d674-4d28-8310-86d28e1d60ac.png',
};
const FavIcon70x70 = {
    rel: 'icon',
    sizes: '70x70',
    href: 'https://pastatic.picsart.com/cms-pastatic/1ff31aba-e714-4481-b046-d9efdf34f581.png',
};
const FavIcon72x72 = {
    rel: 'icon',
    sizes: '72x72',
    href: 'https://pastatic.picsart.com/cms-pastatic/3fbff40d-d674-4d28-8310-86d28e1d60ac.png',
};
const FavIcon76x76 = {
    rel: 'icon',
    sizes: '76x76',
    href: 'https://pastatic.picsart.com/cms-pastatic/6173a517-af50-47c6-be5c-715ddf247910.png',
};
const FavIcon96x96 = {
    rel: 'icon',
    sizes: '96x96',
    href: 'https://pastatic.picsart.com/cms-pastatic/b8ea1213-6194-494b-b32f-aaf6624d22e5.png',
};
const FavIcon114x144 = {
    rel: 'icon',
    sizes: '114x114',
    href: 'https://pastatic.picsart.com/cms-pastatic/454aa78a-a1c8-4462-88db-f6ca03c66b1d.png',
};
const FavIcon120x120 = {
    rel: 'icon',
    sizes: '120x120',
    href: 'https://pastatic.picsart.com/cms-pastatic/791907b2-c4a9-455b-a181-802147b08a72.png',
};
const FavIcon144x144 = {
    rel: 'icon',
    sizes: '144x144',
    href: 'https://pastatic.picsart.com/cms-pastatic/8a03438c-ba6f-4eb7-9888-3290f734caec.png',
};
const FavIcon150x150 = {
    rel: 'icon',
    sizes: '150x150',
    href: 'https://pastatic.picsart.com/cms-pastatic/f961661e-0bce-42fd-b807-8b300c319112.png',
};
const FavIcon152x152 = {
    rel: 'icon',
    sizes: '152x152',
    href: 'https://pastatic.picsart.com/cms-pastatic/aa154f67-2da6-40ea-b308-44a6b316aef5.png',
};
const FavIcon167x167 = {
    rel: 'icon',
    sizes: '167x167',
    href: 'https://pastatic.picsart.com/cms-pastatic/3cec1879-de98-49c0-b2ef-46a381dc4a32.png',
};
const FavIcon180x180 = {
    rel: 'icon',
    sizes: '180x180',
    href: 'https://pastatic.picsart.com/cms-pastatic/9a525713-1b9b-46cf-b47f-cf3f890d2c2a.png',
};
const FavIcon192x192 = {
    rel: 'icon',
    sizes: '192x192',
    href: 'https://pastatic.picsart.com/cms-pastatic/01c2d646-d305-4150-82a7-9482c2e98e17.png',
};
const FavIcon256x256 = {
    rel: 'icon',
    sizes: '256x256',
    href: 'https://pastatic.picsart.com/cms-pastatic/b3a0ded3-c22c-40c6-a46b-ce3d2322b8cc.png',
};
const FavIcon384x384 = {
    rel: 'icon',
    sizes: '384x384',
    href: 'https://pastatic.picsart.com/cms-pastatic/e63b698a-6ccc-4215-a3f4-d56ca9a01d2f.png',
};
const FavIcon512x512 = {
    rel: 'icon',
    sizes: '512x512',
    href: 'https://pastatic.picsart.com/cms-pastatic/e387ca19-1013-4cb2-a290-753e9453d040.png',
};
const FavIcon57x57AppleTouchIcon = {
    rel: 'apple-touch-icons',
    sizes: '57x57',
    href: 'https://pastatic.picsart.com/cms-pastatic/f8f069b8-91fc-4e12-b807-e1196fccd9e4.png',
};
const FavIcon60x60AppleTouchIcon = {
    rel: 'apple-touch-icons',
    sizes: '60x60',
    href: 'https://pastatic.picsart.com/cms-pastatic/3fbff40d-d674-4d28-8310-86d28e1d60ac.png',
};
const FavIcon72x72AppleTouchIcon = {
    rel: 'apple-touch-icons',
    sizes: '72x72',
    href: 'https://pastatic.picsart.com/cms-pastatic/ed8c7a60-c792-4237-8d2b-2ac4baef3102.png',
};
const FavIcon76x76AppleTouchIcon = {
    rel: 'apple-touch-icons',
    sizes: '76x76',
    href: 'https://pastatic.picsart.com/cms-pastatic/6173a517-af50-47c6-be5c-715ddf247910.png',
};
const FavIcon114x114AppleTouchIcon = {
    rel: 'apple-touch-icons',
    sizes: '114x114',
    href: 'https://pastatic.picsart.com/cms-pastatic/454aa78a-a1c8-4462-88db-f6ca03c66b1d.png',
};
const FavIcon120x120AppleTouchIcon = {
    rel: 'apple-touch-icons',
    sizes: '120x120',
    href: 'https://pastatic.picsart.com/cms-pastatic/791907b2-c4a9-455b-a181-802147b08a72.png',
};
const FavIcon152x152AppleTouchIcon = {
    rel: 'apple-touch-icons',
    sizes: '152x152',
    href: 'https://pastatic.picsart.com/cms-pastatic/aa154f67-2da6-40ea-b308-44a6b316aef5.png',
};
const FavIcon167x167AppleTouchIcon = {
    rel: 'apple-touch-icons',
    sizes: '167x167',
    href: 'https://pastatic.picsart.com/cms-pastatic/3cec1879-de98-49c0-b2ef-46a381dc4a32.png',
};
const FavIcon180x180AppleTouchIcon = {
    rel: 'apple-touch-icons',
    sizes: '180x180',
    href: 'https://pastatic.picsart.com/cms-pastatic/9a525713-1b9b-46cf-b47f-cf3f890d2c2a.png',
};

export { FavIcon114x114AppleTouchIcon, FavIcon114x144, FavIcon120x120, FavIcon120x120AppleTouchIcon, FavIcon144x144, FavIcon150x150, FavIcon152x152, FavIcon152x152AppleTouchIcon, FavIcon167x167, FavIcon167x167AppleTouchIcon, FavIcon16x16, FavIcon180x180, FavIcon180x180AppleTouchIcon, FavIcon192x192, FavIcon256x256, FavIcon32x32, FavIcon32x32ShortcutIcon, FavIcon384x384, FavIcon48x48, FavIcon512x512, FavIcon57x57, FavIcon57x57AppleTouchIcon, FavIcon60x60, FavIcon60x60AppleTouchIcon, FavIcon70x70, FavIcon72x72, FavIcon72x72AppleTouchIcon, FavIcon76x76, FavIcon76x76AppleTouchIcon, FavIcon96x96 };
